import { processPods, strapiFetch } from '@/services/strapiService';

export const GetPrivacyPolicy = async ({
    language,
    documentId = '',
}: {
    language: string;
    // documentId replaces the v4 numeric id. v5's findOne route is
    // `/privacy-policies/:documentId` — passing a numeric id 404s.
    documentId?: string;
}) => {
    if (documentId === '') {
        return await strapiFetch(`/privacy-policies`, language);
    }

    const response = await strapiFetch(`/privacy-policies/${documentId}`, language);

    const body = response.body_content ? await processPods(response.body_content) : null;

    const returnvalue = {
        title: response?.title || '',
        description: response?.description || '',
        published_date: response?.published_date || '',
        body,
    };

    return returnvalue;
};
